// AI-authored "bug instruction" for a subtask (backend BugInstructionResponse shape).
// Shape: { id, subtask_id, sql_snippet?, category?, description, created_at, updated_at }.
export default class BugInstruction {
  constructor({
    id = null,
    subtask_id = null,
    sql_snippet = '',
    category = '',
    description = '',
    created_at = null,
    updated_at = null,
  } = {}) {
    this.id = id;
    this.subtask_id = subtask_id;
    this.sql_snippet = sql_snippet;
    this.category = category;
    this.description = description;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }

  // Basic validation for a create/synthesize payload.
  static validate(data) {
    if (!data.subtask_id) {
      throw new Error('Subtask ID is required');
    }
    if (!data.description) {
      throw new Error('Description is required');
    }
  }

  // Bootstrap-5 badge class for a category (best-effort colouring by keyword).
  static categoryClass(category) {
    if (!category) return 'bg-secondary';
    const c = String(category).toLowerCase();
    if (c.includes('logic')) return 'bg-warning text-dark';
    if (c.includes('syntax')) return 'bg-danger';
    if (c.includes('performance')) return 'bg-success';
    if (c.includes('security')) return 'bg-dark';
    return 'bg-info text-dark';
  }
}
